const getBaseUrl = () => {
  if (!window || !window.location) return "";
  let url = `${window.location.protocol}//${window.location.hostname}`;
  if (window.location.port) url = `${url}:${window.location.port}`;
  return url;
};
let baseUrl = '';
baseUrl = getBaseUrl();
// baseUrl = "https://server-47727a6f75333251714a.am.os.inventr.ai";    // Pay.UK server
baseUrl = "https://xbppayerqa-uk-api.exela.global";    // Pay.UK QA server
// baseUrl = "https://xbppayeruat-uk-api.exela.global";    // Pay.UK UAT server
// baseUrl = "https://xbppayer-uk-api.exela.global";    // Pay.UK Prod server

let devBaseUrl = "http://localhost:3001";
devBaseUrl = baseUrl;

const Config = {
  name: "r14-dev-app",
  api: {
    url: process.env.NODE_ENV === "development" ? devBaseUrl : devBaseUrl,
  },
  io: {
    url: process.env.NODE_ENV === "development" ? devBaseUrl : devBaseUrl,
  },
  timeout: 100000,
  loginConfig: {
    biometricsAuth: true,
  },
  headers: {
    "set-cookie": "HttpOnly",
    "X-Frame-Options": "sameorigin",
  },
};
export default Config;